

export class CityStatusInput implements ICityStatusInput {
    /** The auto-generated id of the city master */
    cityId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: ICityStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cityId = _data["cityId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CityStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new CityStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cityId"] = this.cityId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICityStatusInput {
    /** The auto-generated id of the city master */
    cityId: number;
    /** The updated status */
    status: number;
}

